import { usePostPortfolioInvestmentMutation } from "web_myplann/Api/Portfolio/Mutations/usePostPortfolioInvestmentMutation";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import { INVESTMENT_FORM_DEFAULT_VALUES } from "web_myplann/Portfolio/Forms/InvestmentForm/investmentFormDefaults";
import { getInvestmentFormSchema } from "web_myplann/Portfolio/Forms/InvestmentForm/investmentFormSchema";
import { useCreatePortfolioForm } from "web_myplann/Portfolio/PortfolioShared/useCreatePortfolioForm";

export const useCreateInvestmentForm = () => {
	const { t } = useResource();
	const { mutate, isPending } = usePostPortfolioInvestmentMutation();

	const { form, onSubmit } = useCreatePortfolioForm({
		schema: getInvestmentFormSchema(t),
		defaultValues: INVESTMENT_FORM_DEFAULT_VALUES,
		mutate,
		successRoute: Routing.Portfolio.PortfolioAddInvestmentSuccess.path(),
	});

	return { form, onSubmit, isPending };
};
